import {APPLIANCE_URL, AUTH_SESSION_TOKEN, MAPPED_CAPABILITIES} from "../constants/postMessages";

export const getSessionToken = () => {
    return sessionStorage.getItem(AUTH_SESSION_TOKEN);
}
export const setSessionToken = (sessionToken) => {
    sessionStorage.setItem(AUTH_SESSION_TOKEN, sessionToken);
}
export const removeSessionToken = () => {
    sessionStorage.removeItem(AUTH_SESSION_TOKEN);
}

export const getApplianceUrl = () => {
    return sessionStorage.getItem(APPLIANCE_URL);
}
export const setApplianceUrl = (applianceUrl) => {
    sessionStorage.setItem(APPLIANCE_URL, applianceUrl);
}

export const setMappedCapabilities = (mappedCapabilities) => {
    sessionStorage.setItem(MAPPED_CAPABILITIES, mappedCapabilities);
}

export const clearStorage = () => {
    sessionStorage.clear()
}
